export default {
  fetchData({ commit, state }, to) {
    const pageId = to.name === 'home' ? `${to.name}-${to.params.lang}` : to.params.page;
    const currentDataIndex = state.data.findIndex(page => page.id === pageId);
    const promise = new Promise((resolve) => {
      if (currentDataIndex < 0) {
        fetch(`/data/${pageId}.json`)
          .then(response => response.json())
          .then((data) => {
            commit('ADD_DATA_PAGE', { id: pageId, dataPage: data });
            commit('SET_DATA_CURRENTPAGE', data);

            resolve();
          });
      } else {
        commit('SET_DATA_CURRENTPAGE', state.data[currentDataIndex].dataPage);
        resolve();
      }
    });

    return promise;
  },
};
